<template>
  <div class="row tgju-widgets-row dashboard-widgets-technical-list dash-full-height">
    <div class="col-12">
      <div class="tgju-widget light">
		<div class="list-row item-draggable hover bold">
			<div class="list-col l-title l-title-widget-structure">
				<router-link :to="{ name: 'MarketList', params: { market_id: 'list' },}" class="l-item-btn-color-blue">
					لیست داینامیک
				</router-link>
			</div>
			<div class="list-col l-title l-title-widget-structure">
				<router-link :to="{ name: 'MarketStatic', params: { name: 'gold' },}" class="l-item-btn-color-blue">
					لیست بازار طلا
				</router-link>
			</div>
			<div class="list-col l-title l-title-widget-structure">
				<router-link :to="{ name: 'MarketStatic', params: { name: 'currency' },}" class="l-item-btn-color-blue">
					لیست بازار ارز ها
				</router-link>
			</div>
		</div>
      </div>
    </div>
  </div>
</template>

<script>
	// این ویو برای ماژول بازار استفاده میشود
	// این ویو در موبایل قرار است فقط نمایش در بیاید
	export default {
		name: 'MarketView',
		data: function () {
			return {}
		}
	}
</script>